(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[47645],{

/***/ 79341:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/information",
      function () {
        return __webpack_require__(90862);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 78709:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36456);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(75154);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(73637);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(41749);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(22318);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(86010);
/* harmony import */ var _Button_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41107);
/* harmony import */ var _Commitment_Commitment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88737);
/* harmony import */ var _hooks_useAddress__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59361);
/* harmony import */ var _Information_AddressForm__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(12907);
/* harmony import */ var _Global_CMSText__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(94455);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(66026);











function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var useStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function(theme) {
    return (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
        loginFormCard: _defineProperty({
            background: theme.palette.common.white,
            padding: theme.spacing(2)
        }, theme.breakpoints.down('md'), {
            width: '100%'
        }),
        invite: {
            margin: theme.spacing(4, 0)
        },
        form: {
            width: '70%',
            margin: 'auto'
        },
        smallSpace: {
            marginBottom: theme.spacing(2)
        },
        underline: {
            textDecoration: 'underline',
            cursor: 'pointer'
        },
        marginBottom: {
            marginBottom: theme.spacing(2)
        }
    });
});
var mapStateToProps = function(state) {
    return {
        user: state.user
    };
};
var ConnectedForm = function(param) {
    var switchForm = param.switchForm, text = param.text, userFirstName = param.userFirstName, onSubmit = param.onSubmit, user = param.user, t = param.t, hasAddress = param.hasAddress, _isTakeBack = param.isTakeBack, isTakeBack = _isTakeBack === void 0 ? false : _isTakeBack, funnel = param.funnel;
    var ref4, ref1, ref2;
    var classes = useStyles();
    var ref3 = (0,_hooks_useAddress__WEBPACK_IMPORTED_MODULE_5__/* .useAddress */ .S)('shipping'), address = ref3.address, resetInputAddress = ref3.resetInputAddress;
    var commitmentOnLogin = text === null || text === void 0 ? void 0 : text.is_displayed_on_login;
    var noAddress = (hasAddress === null || hasAddress === void 0 ? void 0 : hasAddress.address) !== undefined && Object.keys(hasAddress.address).length === 0 && hasAddress.address.constructor === Object;
    var isSubscription =  false || "date_to_date" === 'classic_subscription';
    var submitConnectedData = function() {
        if (noAddress) {
            onSubmit(address.payload);
        } else {
            var ref;
            onSubmit(user === null || user === void 0 ? void 0 : (ref = user.user) === null || ref === void 0 ? void 0 : ref.address);
        }
        resetInputAddress();
    };
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
        in: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: classes.loginFormCard,
            children: [
                noAddress && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                            container: true,
                            spacing: 1,
                            className: classes.marginBottom,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                item: true,
                                xs: 12,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                    variant: 'h4',
                                    align: "center",
                                    children: [
                                        userFirstName,
                                        ', ',
                                        (0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_7__/* .prismicText */ .yz)(text === null || text === void 0 ? void 0 : text.address_required, t('texts:account:address_required'))
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Information_AddressForm__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            account: isTakeBack,
                            addressType: "shipping",
                            hideAdditionalAddress: funnel === null || funnel === void 0 ? void 0 : (ref4 = funnel.data) === null || ref4 === void 0 ? void 0 : ref4.hide_additional_address,
                            showCompany: _utils_constants__WEBPACK_IMPORTED_MODULE_8__/* .isShippingCompanyEnabled */ .Aq
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                    container: true,
                    justify: "center",
                    children: noAddress && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        variant: 'contained',
                        color: 'primary',
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(classes.smallSpace, 'connected-form__button'),
                        onClick: submitConnectedData,
                        "data-testid": 'Buttoncontinue',
                        disabled: !address.isValid,
                        children: t('texts:account:continue')
                    })
                }),
                !isSubscription && !isTakeBack && (text === null || text === void 0 ? void 0 : text.is_display_guest_link) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: classes.invite,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                        variant: 'body2',
                        color: 'textSecondary',
                        align: "center",
                        className: classes.underline,
                        onClick: function() {
                            return switchForm(2);
                        },
                        children: (0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_7__/* .prismicText */ .yz)(text === null || text === void 0 ? void 0 : text.guest_link, t('texts:account:guest_link'))
                    })
                }),
                !isTakeBack && commitmentOnLogin && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: 'commitment__area',
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Commitment_Commitment__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        icon: (text === null || text === void 0 ? void 0 : (ref1 = text.protected_data_image) === null || ref1 === void 0 ? void 0 : ref1.url) ? text === null || text === void 0 ? void 0 : (ref2 = text.protected_data_image) === null || ref2 === void 0 ? void 0 : ref2.url : null,
                        title: (0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_7__/* .prismicText */ .yz)(text === null || text === void 0 ? void 0 : text.title_data, t('texts:account:title_data')),
                        desc: (0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_7__/* .prismicText */ .yz)(text === null || text === void 0 ? void 0 : text.text_data, t('texts:account:text_data')),
                        center: false
                    })
                })
            ]
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .connect */ .$j)(mapStateToProps)(ConnectedForm));


/***/ }),

/***/ 90862:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var _home_ubuntu_build_wl_front_1_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_ubuntu_build_wl_front_1_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_ubuntu_build_wl_front_1_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_icons_KeyboardBackspace__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(64379);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36456);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var _material_ui_core_Container__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(43832);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(86010);
/* harmony import */ var _components_Information_InformationForm__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6595);
/* harmony import */ var _components_Layout_Layout__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8122);
/* harmony import */ var _components_Funnel_FunnelHeader__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(15802);
/* harmony import */ var _components_Funnel_FunnelBox__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(97991);
/* harmony import */ var _components_Funnel_FunnelAside__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(60291);
/* harmony import */ var _components_Funnel_Funnel_style__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(35042);
/* harmony import */ var _redux_actions_checkout__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(66397);
/* harmony import */ var _redux_actions_user__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(76809);
/* harmony import */ var _components_UserForm_LoginForm__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(90189);
/* harmony import */ var _components_UserForm_RegisterFrom__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(93748);
/* harmony import */ var _components_UserForm_ConnectedForm__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(78709);
/* harmony import */ var _components_Link_Link__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(31520);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(22318);
/* harmony import */ var _components_UserForm_ForgotPasswordForm__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(38269);
/* harmony import */ var _redux_actions_addressUser__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(78101);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(31567);
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(16502);
/* harmony import */ var _hooks_useCartHasStockError__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(45733);
/* harmony import */ var _datapunt_matomo_tracker_react__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(86700);
/* harmony import */ var _components_Loader_Loader__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(96149);
/* harmony import */ var libphonenumber_js_max__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(55400);
/* harmony import */ var _components_Global_CMSText__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(94455);
/* harmony import */ var _redux_actions_prismic__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(64063);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(66026);
/* harmony import */ var _utils_funnel__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(58913);
/* harmony import */ var _redux_actions_cart__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(14596);
/* harmony import */ var _hooks_useVirginSSOAuth__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(93397);
/* harmony import */ var _utils_cart__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(89910);




































function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var mapStateToProps = function(state) {
    return {
        promotions: state.promotions,
        user: state.user,
        parameters: state.parameters,
        cart: state.cart
    };
};
var mapDispatchToProps = {
    getCheckout: _redux_actions_checkout__WEBPACK_IMPORTED_MODULE_11__/* .getCheckout */ .Om,
    createCheckoutAdress: _redux_actions_checkout__WEBPACK_IMPORTED_MODULE_11__/* .createCheckoutAdress */ .LY,
    registerUser: _redux_actions_user__WEBPACK_IMPORTED_MODULE_12__/* .registerUser */ .a$,
    loginUser: _redux_actions_user__WEBPACK_IMPORTED_MODULE_12__/* .loginUser */ .pH,
    getUser: _redux_actions_user__WEBPACK_IMPORTED_MODULE_12__/* .getUser */ .PR,
    postAddress: _redux_actions_addressUser__WEBPACK_IMPORTED_MODULE_18__/* .postAddress */ .L4,
    saveGhostUser: _redux_actions_user__WEBPACK_IMPORTED_MODULE_12__/* .saveGhostUser */ .Eu,
    deleteGhostUser: _redux_actions_user__WEBPACK_IMPORTED_MODULE_12__/* .deleteGhostUser */ .iJ,
    getLastUsedBillingAddress: _redux_actions_cart__WEBPACK_IMPORTED_MODULE_26__/* .getLastUsedBillingAddress */ .PA,
    setInformationSkipped: _redux_actions_cart__WEBPACK_IMPORTED_MODULE_26__/* .setInformationSkipped */ .JM
};
var InformationPage = function(param) {
    var doc = param.doc, main = param.main, basket = param.basket, funnel = param.funnel, parameters = param.parameters, getCheckout1 = param.getCheckout, createCheckoutAdress1 = param.createCheckoutAdress, loginUser1 = param.loginUser, user = param.user, takeback = param.takeback, postAddress1 = param.postAddress, inStoreText = param.inStoreText, promotions = param.promotions, registerUser1 = param.registerUser, getUser1 = param.getUser, account = param.account, saveGhostUser1 = param.saveGhostUser, deleteGhostUser1 = param.deleteGhostUser, faqRes = param.faqRes, banner = param.banner, cart = param.cart, setInformationSkipped1 = param.setInformationSkipped, getLastUsedBillingAddress1 = param.getLastUsedBillingAddress;
    var ref42, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27;
    var classes = (0,_components_Funnel_Funnel_style__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useDispatch */ .I0)();
    var funnelStep = cart === null || cart === void 0 ? void 0 : cart.funnelStep;
    var ref28 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({
        field: '',
        message: ''
    }), error = ref28[0];
    var ref29 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), login = ref29[0], setIsLoginForm = ref29[1];
    var ref30 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), register1 = ref30[0], setIsRegisterForm = ref30[1];
    var ref31 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), ghostUser = ref31[0], setIsGhostUser = ref31[1];
    var ref32 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), hasRegistered = ref32[0], setHasRegistered = ref32[1];
    var ref33 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), errorPhone = ref33[0], setHasErrorPhone = ref33[1];
    var ref34 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), errorAccountDisabled = ref34[0], setErrorAccountDisabled = ref34[1];
    var ref35 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), errorEmailUsed = ref35[0], setErrorEmailUsed = ref35[1];
    var ref36 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), forgot = ref36[0], setIsForgotForm = ref36[1];
    var ref37 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), loginError = ref37[0], setLoginError = ref37[1];
    var ref38 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), hasError = ref38[0], setHasError = ref38[1];
    var ref39 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isConnected = ref39[0], setIsConnected = ref39[1];
    var ref40 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), hasLogin = ref40[0], setHasLogin = ref40[1];
    var hasStockError = (0,_hooks_useCartHasStockError__WEBPACK_IMPORTED_MODULE_20__/* .useCartHasStockError */ .V)();
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_29__/* .useTranslation */ .$)().t;
    var ref41 = (0,_datapunt_matomo_tracker_react__WEBPACK_IMPORTED_MODULE_30__/* ["default"] */ .Z)(), trackPageView = ref41.trackPageView, trackEvent = ref41.trackEvent;
    var isLoginFirst = doc === null || doc === void 0 ? void 0 : (ref42 = doc.data) === null || ref42 === void 0 ? void 0 : ref42.first_form_to_show;
    var funnelContentRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var store = "millet";
    var isVirginUser = store === 'virgin';
    var isCheckingAuth = (isVirginUser ? (0,_hooks_useVirginSSOAuth__WEBPACK_IMPORTED_MODULE_27__/* .useVirginSSOAuth */ .S)(router, false) : {
        isCheckingAuth: false
    }).isCheckingAuth;
    var backToInformation = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        var ref;
        return doc === null || doc === void 0 ? void 0 : (ref = doc.data) === null || ref === void 0 ? void 0 : ref.enable_back_to_informations;
    }, [
        doc === null || doc === void 0 ? void 0 : (ref1 = doc.data) === null || ref1 === void 0 ? void 0 : ref1.enable_back_to_informations
    ]);
    var information = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        var ref;
        var billingAddress = cart === null || cart === void 0 ? void 0 : (ref = cart.item) === null || ref === void 0 ? void 0 : ref.billingAddress;
        var _ref = (user === null || user === void 0 ? void 0 : user.user) || {}, address = _ref.address, userInfos = _objectWithoutProperties(_ref, [
            "address"
        ]);
        if (billingAddress) {
            return _objectSpread({}, billingAddress, userInfos && _objectSpread({}, userInfos));
        } else if (address) {
            var ref43;
            return _objectSpread({}, address, {
                email: user === null || user === void 0 ? void 0 : (ref43 = user.user) === null || ref43 === void 0 ? void 0 : ref43.email
            });
        }
        return null;
    }, [
        cart === null || cart === void 0 ? void 0 : (ref2 = cart.item) === null || ref2 === void 0 ? void 0 : ref2.billingAddress,
        user === null || user === void 0 ? void 0 : user.user
    ]);
    var redirectToShipping = function() {
        if (hasStockError) return;
        router.push('/shipping');
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        dispatch((0,_redux_actions_prismic__WEBPACK_IMPORTED_MODULE_23__/* .SAVE_PRISMIC_DOCUMENTS */ .w)({
            general: main === null || main === void 0 ? void 0 : main.data,
            funnel: funnel === null || funnel === void 0 ? void 0 : funnel.data,
            account: account === null || account === void 0 ? void 0 : account.data,
            basket: basket === null || basket === void 0 ? void 0 : basket.data,
            instore: inStoreText === null || inStoreText === void 0 ? void 0 : inStoreText.data
        }));
    }, [
        funnel,
        main,
        account,
        basket,
        inStoreText
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        {
            // Redirect to shop page if no products in cart
            cart && cart.item && cart.item.items.length === 0 && router.push('/shop');
            (0,_utils_utils__WEBPACK_IMPORTED_MODULE_19__/* .checkTryOutError */ .HC)(cart) && router.push('/shop');
        }
    }, [
        cart === null || cart === void 0 ? void 0 : (ref3 = cart.item) === null || ref3 === void 0 ? void 0 : ref3.items
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var ref;
        if ((user === null || user === void 0 ? void 0 : (ref = user.user) === null || ref === void 0 ? void 0 : ref.id) && !hasLogin) {
            setIsConnected(true);
            setIsLoginForm(false);
            setIsRegisterForm(false);
        } else {
            var ref44;
            setIsConnected(false);
            if (isLoginFirst) {
                setIsLoginForm(true);
                setIsRegisterForm(false);
            } else if ((cart === null || cart === void 0 ? void 0 : (ref44 = cart.item) === null || ref44 === void 0 ? void 0 : ref44.billingAddress) && backToInformation) {
                setIsGhostUser(true);
                setIsLoginForm(false);
                setIsRegisterForm(false);
            } else {
                setIsLoginForm(false);
                setIsRegisterForm(true);
            }
        }
    }, [
        user === null || user === void 0 ? void 0 : user.user,
        hasLogin,
        cart === null || cart === void 0 ? void 0 : (ref4 = cart.item) === null || ref4 === void 0 ? void 0 : ref4.billingAddress,
        backToInformation
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var ref, ref45, ref46;
        var shouldSkip = isConnected && (!_utils_constants__WEBPACK_IMPORTED_MODULE_24__/* .isB2B */ .tP || _utils_constants__WEBPACK_IMPORTED_MODULE_24__/* .isB2B */ .tP && (cart === null || cart === void 0 ? void 0 : (ref = cart.item) === null || ref === void 0 ? void 0 : ref.billingAddress)) && !!(user === null || user === void 0 ? void 0 : (ref45 = user.user) === null || ref45 === void 0 ? void 0 : (ref46 = ref45.address) === null || ref46 === void 0 ? void 0 : ref46.city) && (!backToInformation || backToInformation && funnelStep !== 0);
        // Mémorise si l'étape /information est réellement sautée, pour masquer son
        // onglet dans le stepper des étapes suivantes (seulement si l'état change,
        // pour éviter des dispatch/re-renders inutiles).
        if ((cart === null || cart === void 0 ? void 0 : cart.informationSkipped) !== shouldSkip) {
            setInformationSkipped1(shouldSkip);
        }
        if (shouldSkip) {
            var ref47, ref48;
            getCheckout1(cart === null || cart === void 0 ? void 0 : (ref47 = cart.item) === null || ref47 === void 0 ? void 0 : ref47.tokenValue);
            localStorage.setItem('email', user === null || user === void 0 ? void 0 : (ref48 = user.user) === null || ref48 === void 0 ? void 0 : ref48.email);
            //onSubmit(data)
            redirectToShipping();
        }
    }, [
        user === null || user === void 0 ? void 0 : user.user,
        isConnected,
        cart === null || cart === void 0 ? void 0 : (ref5 = cart.item) === null || ref5 === void 0 ? void 0 : ref5.billingAddress,
        cart === null || cart === void 0 ? void 0 : cart.informationSkipped,
        _utils_constants__WEBPACK_IMPORTED_MODULE_24__/* .isB2B */ .tP,
        backToInformation,
        funnelStep, 
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var ref50, ref49;
        if (_utils_constants__WEBPACK_IMPORTED_MODULE_24__/* .isThermorSSO */ .y) return;
        if (_utils_constants__WEBPACK_IMPORTED_MODULE_24__/* .isB2B */ .tP && (user === null || user === void 0 ? void 0 : (ref50 = user.user) === null || ref50 === void 0 ? void 0 : ref50.id) && !(cart === null || cart === void 0 ? void 0 : cart.loading) && (cart === null || cart === void 0 ? void 0 : cart.item) && !(cart === null || cart === void 0 ? void 0 : (ref49 = cart.item) === null || ref49 === void 0 ? void 0 : ref49.billingAddress)) {
            var setLastUsedBillingAddress = function() {
                var _ref = _asyncToGenerator(_home_ubuntu_build_wl_front_1_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var lastUsedBillingAddress, ref;
                    return _home_ubuntu_build_wl_front_1_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                _ctx.next = 2;
                                return getLastUsedBillingAddress1();
                            case 2:
                                lastUsedBillingAddress = _ctx.sent;
                                if (lastUsedBillingAddress && Object.keys(lastUsedBillingAddress).length > 0) {
                                    ;
                                    createCheckoutAdress1(cart === null || cart === void 0 ? void 0 : (ref = cart.item) === null || ref === void 0 ? void 0 : ref.tokenValue, {
                                        billingAddress: lastUsedBillingAddress
                                    });
                                }
                            case 4:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }));
                return function setLastUsedBillingAddress() {
                    return _ref.apply(this, arguments);
                };
            }();
            setLastUsedBillingAddress();
        }
    }, [
        user === null || user === void 0 ? void 0 : user.user,
        cart,
        _utils_constants__WEBPACK_IMPORTED_MODULE_24__/* .isB2B */ .tP
    ]);
    var submitLogin = function() {
        var _ref = _asyncToGenerator(_home_ubuntu_build_wl_front_1_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(data) {
            var log, ref, ref51, ref52;
            return _home_ubuntu_build_wl_front_1_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        localStorage.removeItem(_utils_constants__WEBPACK_IMPORTED_MODULE_24__/* .LOCAL_STORAGE_KEYS.TOKEN */ .dA.TOKEN);
                        _ctx.next = 3;
                        return loginUser1(data);
                    case 3:
                        log = _ctx.sent;
                        setLoginError(false);
                        if (!(log.type === 'LOGIN_USER_FAILURE')) {
                            _ctx.next = 11;
                            break;
                        }
                        ;
                        if ((log === null || log === void 0 ? void 0 : (ref = log.err) === null || ref === void 0 ? void 0 : (ref51 = ref.response) === null || ref51 === void 0 ? void 0 : (ref52 = ref51.data) === null || ref52 === void 0 ? void 0 : ref52.message) === 'Account is disabled.') {
                            setErrorAccountDisabled(true);
                        } else {
                            setLoginError(true);
                            setIsConnected(false);
                            setIsLoginForm(true);
                        }
                        return _ctx.abrupt("return");
                    case 11:
                        {
                            setLoginError(false);
                            setIsRegisterForm(false);
                            setIsConnected(true);
                            setIsLoginForm(false);
                            if (log.token.token) {
                                localStorage.setItem('TOKEN', log.token.token);
                                getUser1();
                            }
                        }
                    case 12:
                        if (user === null || user === void 0 ? void 0 : user.ghostUser) deleteGhostUser1();
                        redirectToShipping();
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function submitLogin(data) {
            return _ref.apply(this, arguments);
        };
    }();
    var submitRegistration = function() {
        var _ref = _asyncToGenerator(_home_ubuntu_build_wl_front_1_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(data) {
            var register, ref, dataLogin, ref53, ref54, ref55, ref56, ref57, err;
            return _home_ubuntu_build_wl_front_1_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        localStorage.removeItem(_utils_constants__WEBPACK_IMPORTED_MODULE_24__/* .LOCAL_STORAGE_KEYS.TOKEN */ .dA.TOKEN);
                        setHasError(false);
                        setErrorEmailUsed(false);
                        setHasErrorPhone(false);
                        if (![
                            'MOBILE',
                            'FIXED_LINE_OR_MOBILE'
                        ].includes((0,libphonenumber_js_max__WEBPACK_IMPORTED_MODULE_31__/* .parsePhoneNumberFromString */ ._)(data === null || data === void 0 ? void 0 : data.phoneNumber).getType())) {
                            _ctx.next = 11;
                            break;
                        }
                        _ctx.next = 7;
                        return registerUser1(data);
                    case 7:
                        register = _ctx.sent;
                        if (register.type === 'REGISTER_USER_SUCCESS') {
                            ;
                            trackEvent({
                                category: "Information funnel",
                                action: 'Customer has successfully created his account'
                            });
                            if (!(parameters === null || parameters === void 0 ? void 0 : (ref = parameters.items) === null || ref === void 0 ? void 0 : ref.isAccountVerificationRequired)) {
                                dataLogin = {
                                    email: data.email,
                                    password: data.plainPassword
                                };
                                submitLogin(dataLogin);
                                setIsRegisterForm(false);
                                setIsLoginForm(true);
                                setHasRegistered(true);
                                setHasLogin(false);
                            } else {
                                setIsRegisterForm(false);
                                setIsLoginForm(true);
                                setHasRegistered(true);
                            }
                        } else {
                            ;
                            trackEvent({
                                category: "Information funnel",
                                action: "Customer account creation failure"
                            });
                            err = register === null || register === void 0 ? void 0 : (ref53 = register.err) === null || ref53 === void 0 ? void 0 : (ref54 = ref53.response) === null || ref54 === void 0 ? void 0 : (ref55 = ref54.data) === null || ref55 === void 0 ? void 0 : (ref56 = ref55.errors) === null || ref56 === void 0 ? void 0 : (ref57 = ref56.email) === null || ref57 === void 0 ? void 0 : ref57[0];
                            if ((err === null || err === void 0 ? void 0 : err.length) > 0 && err === 'This email is already used.') {
                                setErrorEmailUsed(true);
                            } else {
                                setHasError(true);
                            }
                        }
                        _ctx.next = 12;
                        break;
                    case 11:
                        {
                            setHasErrorPhone(true);
                        }
                    case 12:
                        if (user === null || user === void 0 ? void 0 : user.ghostUser) deleteGhostUser1();
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function submitRegistration(data) {
            return _ref.apply(this, arguments);
        };
    }();
    var switchForm = function(id) {
        setIsRegisterForm(false);
        setIsGhostUser(false);
        setIsConnected(false);
        setLoginError(false);
        setHasError(false);
        setErrorEmailUsed(false);
        setErrorAccountDisabled(false);
        setHasErrorPhone(false);
        setIsForgotForm(false);
        setIsLoginForm(false);
        switch(id){
            case 1:
                setIsRegisterForm(true);
                trackEvent({
                    category: "Information funnel",
                    action: "Open Registration Form"
                });
                break;
            case 2:
                setIsGhostUser(true);
                trackEvent({
                    category: "Information funnel",
                    action: "Go as Ghost User"
                });
                break;
            case 3:
                setIsConnected(true);
                trackEvent({
                    category: "Information funnel",
                    action: "Logged in successfully"
                });
                break;
            case 4:
                setIsLoginForm(true);
                trackEvent({
                    category: "Information funnel",
                    action: "Open Login Form"
                });
                break;
            case 5:
                setIsForgotForm(true);
                trackEvent({
                    category: "Information funnel",
                    action: "Open Forget password Form"
                });
                break;
            default:
                break;
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        trackPageView({
            documentTitle: 'Information'
        });
    /*window?.scrollTo({
      top: funnelContentRef.current.offsetTop,
      behavior: 'smooth',
    })*/ }, [
        switchForm
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (false) {}
    }, [
        promotions
    ]);
    var onSubmit = function() {
        var _ref = _asyncToGenerator(_home_ubuntu_build_wl_front_1_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(shippingAddress, billingAddress) {
            var checkoutInfos, checkAddress, ref, ref58, ref59, ref60;
            return _home_ubuntu_build_wl_front_1_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setHasErrorPhone(false);
                        if (!((shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.phoneNumber) && [
                            'MOBILE',
                            'FIXED_LINE_OR_MOBILE'
                        ].includes((0,libphonenumber_js_max__WEBPACK_IMPORTED_MODULE_31__/* .parsePhoneNumberFromString */ ._)(shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.phoneNumber).getType()))) {
                            _ctx.next = 21;
                            break;
                        }
                        checkoutInfos = {
                            billingAddress: (0,_utils_cart__WEBPACK_IMPORTED_MODULE_28__/* .billingAddressForThermorCheckoutPut */ .jC)(billingAddress !== null && billingAddress !== void 0 ? billingAddress : shippingAddress, cart === null || cart === void 0 ? void 0 : cart.item),
                            shippingAddress: shippingAddress
                        };
                        if (!(cart === null || cart === void 0 ? void 0 : cart.item)) {
                            _ctx.next = 19;
                            break;
                        }
                        setHasError(false);
                        setHasErrorPhone(false);
                        _ctx.next = 8;
                        return createCheckoutAdress1(cart.item.tokenValue, checkoutInfos);
                    case 8:
                        checkAddress = _ctx.sent;
                        if (!(_utils_constants__WEBPACK_IMPORTED_MODULE_24__/* .isB2B */ .tP && isConnected)) {
                            _ctx.next = 14;
                            break;
                        }
                        _ctx.next = 12;
                        return onConnectedSubmit(shippingAddress);
                    case 12:
                        _ctx.next = 18;
                        break;
                    case 14:
                        ;
                        _ctx.next = 17;
                        return getCheckout1(cart === null || cart === void 0 ? void 0 : (ref = cart.item) === null || ref === void 0 ? void 0 : ref.tokenValue);
                    case 17:
                        saveGhostUser1({
                            firstName: checkoutInfos.billingAddress.firstName,
                            lastName: checkoutInfos.billingAddress.lastName,
                            email: checkoutInfos.billingAddress.email
                        });
                    case 18:
                        if (checkAddress.type === 'PUT_CHECKOUT_ADDRESS_SUCCESS') {
                            setHasError(false);
                            setHasErrorPhone(false);
                            trackEvent({
                                category: "Information funnel",
                                action: "Go to Shipping"
                            });
                            redirectToShipping();
                        } else if (checkAddress.type === 'PUT_CHECKOUT_ADDRESS_FAILURE') {
                            ;
                            if ((checkAddress === null || checkAddress === void 0 ? void 0 : (ref58 = checkAddress.err) === null || ref58 === void 0 ? void 0 : (ref59 = ref58.response) === null || ref59 === void 0 ? void 0 : (ref60 = ref59.data) === null || ref60 === void 0 ? void 0 : ref60.message) === 'Validation failed') {
                                setHasErrorPhone(true);
                                trackEvent({
                                    category: "Information funnel",
                                    action: "Go to Shipping Fail, Incorrect Phone Number"
                                });
                            } else {
                                setHasError(true);
                                setHasErrorPhone(false);
                                trackEvent({
                                    category: "Information funnel",
                                    action: "Go to Shipping Fail"
                                });
                            }
                        }
                    case 19:
                        _ctx.next = 22;
                        break;
                    case 21:
                        {
                            setHasErrorPhone(true);
                        }
                    case 22:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onSubmit(shippingAddress, billingAddress) {
            return _ref.apply(this, arguments);
        };
    }();
    var onConnectedSubmit = function() {
        var _ref = _asyncToGenerator(_home_ubuntu_build_wl_front_1_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(shippingAddress) {
            var ref, ref61, ref62, userInfos, billingInfos;
            return _home_ubuntu_build_wl_front_1_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        setHasLogin(false);
                        userInfos = {
                            firstName: user === null || user === void 0 ? void 0 : (ref = user.user) === null || ref === void 0 ? void 0 : ref.firstName,
                            lastName: user === null || user === void 0 ? void 0 : (ref61 = user.user) === null || ref61 === void 0 ? void 0 : ref61.lastName,
                            phoneNumber: user === null || user === void 0 ? void 0 : (ref62 = user.user) === null || ref62 === void 0 ? void 0 : ref62.phoneNumber
                        };
                        ;
                        if (!shippingAddress) {
                            _ctx.next = 10;
                            break;
                        }
                        billingInfos = _objectSpread({}, userInfos, shippingAddress);
                        _ctx.next = 8;
                        return postAddress1(billingInfos);
                    case 8:
                        _ctx.next = 10;
                        return getUser1();
                    case 10:
                        setHasLogin(true);
                        _ctx.t0 = cart === null || cart === void 0 ? void 0 : cart.item;
                        if (!_ctx.t0) {
                            _ctx.next = 15;
                            break;
                        }
                        _ctx.next = 15;
                        return getCheckout1(cart.item.tokenValue);
                    case 15:
                        localStorage.setItem('email', user.user.email);
                        trackEvent({
                            category: "Information funnel",
                            action: "Logged user Go to Shipping"
                        });
                        if (!_utils_constants__WEBPACK_IMPORTED_MODULE_24__/* .isB2B */ .tP) {
                            redirectToShipping();
                        }
                    case 18:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onConnectedSubmit(shippingAddress) {
            return _ref.apply(this, arguments);
        };
    }();
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_Layout_Layout__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        mainLogo: main === null || main === void 0 ? void 0 : (ref6 = main.data) === null || ref6 === void 0 ? void 0 : ref6.logo,
        doc: main,
        metaTitle: (0,_components_Global_CMSText__WEBPACK_IMPORTED_MODULE_22__/* .prismicText */ .yz)(doc === null || doc === void 0 ? void 0 : (ref7 = doc.data) === null || ref7 === void 0 ? void 0 : ref7.meta_title_information, t('texts:funnel:information')),
        hideTop: true,
        t: t,
        inStoreText: inStoreText,
        metaDescription: doc === null || doc === void 0 ? void 0 : (ref8 = doc.data) === null || ref8 === void 0 ? void 0 : ref8.meta_description_information,
        metaKeywords: doc === null || doc === void 0 ? void 0 : (ref9 = doc.data) === null || ref9 === void 0 ? void 0 : ref9.meta_keywords_information,
        basket: basket,
        takeback: takeback,
        account: account,
        faq: faqRes,
        banner: banner,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("main", {
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z)('information', 'checkout', classes.root),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z)('funnel', classes.funnel),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core_Container__WEBPACK_IMPORTED_MODULE_33__/* ["default"] */ .Z, {
                    maxWidth: 'xl',
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: classes.funnelLayout,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: classes.funnelContent,
                                ref: funnelContentRef,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_Funnel_FunnelHeader__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                        title: (doc === null || doc === void 0 ? void 0 : (ref10 = doc.data) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.steps) === null || ref11 === void 0 ? void 0 : (ref12 = ref11[0]) === null || ref12 === void 0 ? void 0 : (ref13 = ref12['title']) === null || ref13 === void 0 ? void 0 : (ref14 = ref13[0]) === null || ref14 === void 0 ? void 0 : ref14.text) ? doc === null || doc === void 0 ? void 0 : (ref15 = doc.data) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.steps) === null || ref16 === void 0 ? void 0 : (ref17 = ref16[0]) === null || ref17 === void 0 ? void 0 : (ref18 = ref17['title']) === null || ref18 === void 0 ? void 0 : (ref19 = ref18[0]) === null || ref19 === void 0 ? void 0 : ref19.text : t('texts:funnel:information')
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_components_Funnel_FunnelBox__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                        steps: (0,_utils_funnel__WEBPACK_IMPORTED_MODULE_25__/* .getStepperSteps */ .S8)(doc === null || doc === void 0 ? void 0 : (ref20 = doc.data) === null || ref20 === void 0 ? void 0 : ref20.steps, doc === null || doc === void 0 ? void 0 : (ref21 = doc.data) === null || ref21 === void 0 ? void 0 : ref21.order_reference_label),
                                        t: t,
                                        activeStep: 0,
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_Link_Link__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                                href: '/shop',
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                                    onClick: function() {
                                                        return trackEvent({
                                                            category: "Information funnel",
                                                            action: "Return to shop"
                                                        });
                                                    },
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_34__/* ["default"] */ .Z, {
                                                        variant: 'body2',
                                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z)(classes.backLink, 'backLink'),
                                                        component: "span",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_icons_KeyboardBackspace__WEBPACK_IMPORTED_MODULE_35__/* ["default"] */ .Z, {
                                                                className: classes.backArrow
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_Global_CMSText__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .ZP, {
                                                                    asText: true,
                                                                    data: doc === null || doc === void 0 ? void 0 : (ref22 = doc.data) === null || ref22 === void 0 ? void 0 : ref22.return_button,
                                                                    defaultText: t('texts:funnel:return_button')
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            }),
                                            (ghostUser || funnelStep === 0 && isConnected) && !user.loading && (!(isConnected && !(user === null || user === void 0 ? void 0 : (ref23 = user.user) === null || ref23 === void 0 ? void 0 : (ref24 = ref23.address) === null || ref24 === void 0 ? void 0 : ref24.city)) || _utils_constants__WEBPACK_IMPORTED_MODULE_24__/* .isB2B */ .tP && isConnected) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_Information_InformationForm__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                onSubmit: onSubmit,
                                                switchForm: switchForm,
                                                t: t,
                                                information: information,
                                                error: error,
                                                hasError: hasError,
                                                errorPhone: errorPhone,
                                                disabled: hasStockError,
                                                text: doc === null || doc === void 0 ? void 0 : doc.data,
                                                accountText: account === null || account === void 0 ? void 0 : account.data,
                                                cart: cart,
                                                generalConfigData: main === null || main === void 0 ? void 0 : main.data,
                                                prismicFunnelData: doc === null || doc === void 0 ? void 0 : doc.data,
                                                prefill: !!information
                                            }),
                                            login && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_UserForm_LoginForm__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                                hasRegistered: hasRegistered,
                                                submitLogin: submitLogin,
                                                loginError: loginError,
                                                t: t,
                                                errorAccountDisabled: errorAccountDisabled,
                                                switchForm: switchForm,
                                                isLoading: user.loading,
                                                text: account === null || account === void 0 ? void 0 : account.data,
                                                isFunnel: true
                                            }),
                                            register1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_UserForm_RegisterFrom__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                                submitRegistration: submitRegistration,
                                                switchForm: switchForm,
                                                isLoading: user.loading,
                                                errorPhone: errorPhone,
                                                t: t,
                                                errorEmailUsed: errorEmailUsed,
                                                hasError: hasError,
                                                text: account === null || account === void 0 ? void 0 : account.data,
                                                isFunnel: true,
                                                generalConfigData: main === null || main === void 0 ? void 0 : main.data
                                            }),
                                            !_utils_constants__WEBPACK_IMPORTED_MODULE_24__/* .isB2B */ .tP && isConnected && !(user === null || user === void 0 ? void 0 : (ref25 = user.user) === null || ref25 === void 0 ? void 0 : (ref26 = ref25.address) === null || ref26 === void 0 ? void 0 : ref26.city) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                                children: !hasLogin ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_UserForm_ConnectedForm__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                                    onSubmit: onConnectedSubmit,
                                                    text: account === null || account === void 0 ? void 0 : account.data,
                                                    t: t,
                                                    switchForm: switchForm,
                                                    userFirstName: user === null || user === void 0 ? void 0 : (ref27 = user.user) === null || ref27 === void 0 ? void 0 : ref27.firstName,
                                                    hasAddress: user === null || user === void 0 ? void 0 : user.user,
                                                    funnel: funnel
                                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                    className: classes.loaderContainer,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_Loader_Loader__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {})
                                                })
                                            }),
                                            forgot && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_UserForm_ForgotPasswordForm__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                                isFunnel: true,
                                                t: t,
                                                text: account === null || account === void 0 ? void 0 : account.data,
                                                switchForm: switchForm
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: classes.funnelAside,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_Funnel_FunnelAside__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                    text: funnel === null || funnel === void 0 ? void 0 : funnel.data,
                                    basket: basket,
                                    parameters: parameters,
                                    settings: main,
                                    takeback: takeback
                                })
                            })
                        ]
                    })
                })
            })
        })
    }));
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = ((0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .connect */ .$j)(mapStateToProps, mapDispatchToProps)(InformationPage));


/***/ }),

/***/ 78101:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Kn": function() { return /* binding */ addressUser_getAddress; },
  "Pe": function() { return /* binding */ addressUser_patchAddress; },
  "L4": function() { return /* binding */ addressUser_postAddress; },
  "EJ": function() { return /* binding */ addressUser_putAddress; }
});

// UNUSED EXPORTS: ACTIONS, GET_ADDRESS_USER_FAILURE, GET_ADDRESS_USER_REQUEST, GET_ADDRESS_USER_SUCCESS, PATCH_ADDRESS_USER_FAILURE, PATCH_ADDRESS_USER_REQUEST, PATCH_ADDRESS_USER_SUCCESS, POST_ADDRESS_USER_FAILURE, POST_ADDRESS_USER_REQUEST, POST_ADDRESS_USER_SUCCESS, PUT_ADDRESS_USER_FAILURE, PUT_ADDRESS_USER_REQUEST, PUT_ADDRESS_USER_SUCCESS

// EXTERNAL MODULE: ./utils/constants.tsx
var constants = __webpack_require__(66026);
// EXTERNAL MODULE: ./utils/utils.tsx
var utils = __webpack_require__(16502);
// EXTERNAL MODULE: ./redux/helpers/api.ts + 1 modules
var api = __webpack_require__(12664);
// EXTERNAL MODULE: ./redux/helpers/requests.ts
var requests = __webpack_require__(20031);
;// CONCATENATED MODULE: ./redux/services/addressUser.ts




var getAddress = function() {
    return (0,api/* default */.ZP)({
        method: requests/* EMethods.get */.YZ.get,
        url: requests/* ERequestUrl.address */.KU.address,
        headers: (0,utils/* apiHeaders */.pW)(localStorage.getItem(constants/* LOCAL_STORAGE_KEYS.CONNEXION_TYPE */.dA.CONNEXION_TYPE))
    });
};
var postAddress = function(data) {
    return (0,api/* default */.ZP)({
        method: requests/* EMethods.post */.YZ.post,
        url: requests/* ERequestUrl.address */.KU.address,
        data: data,
        headers: (0,utils/* apiHeaders */.pW)(localStorage.getItem(constants/* LOCAL_STORAGE_KEYS.CONNEXION_TYPE */.dA.CONNEXION_TYPE))
    });
};
var putAddress = function(data, id) {
    return (0,api/* default */.ZP)({
        method: requests/* EMethods.put */.YZ.put,
        url: requests/* ERequestUrl.address */.KU.address,
        data: data,
        uid: id.toString(),
        headers: (0,utils/* apiHeaders */.pW)(localStorage.getItem(constants/* LOCAL_STORAGE_KEYS.CONNEXION_TYPE */.dA.CONNEXION_TYPE))
    });
};
var patchAddress = function(id) {
    return (0,api/* default */.ZP)({
        method: requests/* EMethods.patch */.YZ.patch,
        url: requests/* ERequestUrl.address */.KU.address,
        uid: "".concat(id.toString(), "/default"),
        headers: (0,utils/* apiHeaders */.pW)(localStorage.getItem(constants/* LOCAL_STORAGE_KEYS.CONNEXION_TYPE */.dA.CONNEXION_TYPE))
    });
};

;// CONCATENATED MODULE: ./redux/actions/addressUser.ts

var ACTIONS = {
    GET_ADDRESS_USER_REQUEST: 'GET_ADDRESS_USER_REQUEST',
    GET_ADDRESS_USER_SUCCESS: 'GET_ADDRESS_USER_SUCCESS',
    GET_ADDRESS_USER_FAILURE: 'GET_ADDRESS_USER_FAILURE',
    POST_ADDRESS_USER_REQUEST: 'POST_ADDRESS_USER_REQUEST',
    POST_ADDRESS_USER_SUCCESS: 'POST_ADDRESS_USER_SUCCESS',
    POST_ADDRESS_USER_FAILURE: 'POST_ADDRESS_USER_FAILURE',
    PUT_ADDRESS_USER_REQUEST: 'PUT_ADDRESS_USER_REQUEST',
    PUT_ADDRESS_USER_SUCCESS: 'PUT_ADDRESS_USER_SUCCESS',
    PUT_ADDRESS_USER_FAILURE: 'PUT_ADDRESS_USER_FAILURE',
    PATCH_ADDRESS_USER_REQUEST: 'PATCH_ADDRESS_USER_REQUEST',
    PATCH_ADDRESS_USER_SUCCESS: 'PATCH_ADDRESS_USER_SUCCESS',
    PATCH_ADDRESS_USER_FAILURE: 'PATCH_ADDRESS_USER_FAILURE'
};
var GET_ADDRESS_USER_REQUEST = function() {
    return {
        type: ACTIONS.GET_ADDRESS_USER_REQUEST
    };
};
var GET_ADDRESS_USER_SUCCESS = function(address) {
    return {
        type: ACTIONS.GET_ADDRESS_USER_SUCCESS,
        address: address
    };
};
var GET_ADDRESS_USER_FAILURE = function(err) {
    return {
        type: ACTIONS.GET_ADDRESS_USER_FAILURE,
        err: err
    };
};
function addressUser_getAddress() {
    return function(dispatch) {
        dispatch(GET_ADDRESS_USER_REQUEST());
        return getAddress().then(function(response) {
            return dispatch(GET_ADDRESS_USER_SUCCESS(response));
        }, function(err) {
            return dispatch(GET_ADDRESS_USER_FAILURE(err));
        });
    };
}
var POST_ADDRESS_USER_REQUEST = function() {
    return {
        type: ACTIONS.POST_ADDRESS_USER_REQUEST
    };
};
var POST_ADDRESS_USER_SUCCESS = function(address) {
    return {
        type: ACTIONS.POST_ADDRESS_USER_SUCCESS,
        address: address
    };
};
var POST_ADDRESS_USER_FAILURE = function(err) {
    return {
        type: ACTIONS.POST_ADDRESS_USER_FAILURE,
        err: err
    };
};
function addressUser_postAddress(data) {
    return function(dispatch) {
        dispatch(POST_ADDRESS_USER_REQUEST());
        return postAddress(data).then(function(response) {
            return dispatch(POST_ADDRESS_USER_SUCCESS(response));
        }, function(err) {
            return dispatch(POST_ADDRESS_USER_FAILURE(err));
        });
    };
}
var PUT_ADDRESS_USER_REQUEST = function() {
    return {
        type: ACTIONS.PUT_ADDRESS_USER_REQUEST
    };
};
var PUT_ADDRESS_USER_SUCCESS = function(address) {
    return {
        type: ACTIONS.PUT_ADDRESS_USER_SUCCESS,
        address: address
    };
};
var PUT_ADDRESS_USER_FAILURE = function(err) {
    return {
        type: ACTIONS.PUT_ADDRESS_USER_FAILURE,
        err: err
    };
};
function addressUser_putAddress(data, id) {
    return function(dispatch) {
        dispatch(PUT_ADDRESS_USER_REQUEST());
        return putAddress(data, id).then(function(response) {
            return dispatch(PUT_ADDRESS_USER_SUCCESS(response));
        }, function(err) {
            return dispatch(PUT_ADDRESS_USER_FAILURE(err));
        });
    };
}
var PATCH_ADDRESS_USER_REQUEST = function() {
    return {
        type: ACTIONS.PATCH_ADDRESS_USER_REQUEST
    };
};
var PATCH_ADDRESS_USER_SUCCESS = function(address) {
    return {
        type: ACTIONS.PATCH_ADDRESS_USER_SUCCESS,
        address: address
    };
};
var PATCH_ADDRESS_USER_FAILURE = function(err) {
    return {
        type: ACTIONS.PATCH_ADDRESS_USER_FAILURE,
        err: err
    };
};
function addressUser_patchAddress(id) {
    return function(dispatch) {
        dispatch(PATCH_ADDRESS_USER_REQUEST());
        return patchAddress(id).then(function(response) {
            return dispatch(PATCH_ADDRESS_USER_SUCCESS(response));
        }, function(err) {
            return dispatch(PATCH_ADDRESS_USER_FAILURE(err));
        });
    };
}


/***/ }),

/***/ 34853:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm; }
});

// UNUSED EXPORTS: ReCAPTCHA

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./node_modules/react-google-recaptcha/lib/esm/recaptcha.js
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }




var ReCAPTCHA =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ReCAPTCHA, _React$Component);

  function ReCAPTCHA() {
    var _this;

    _this = _React$Component.call(this) || this;
    _this.handleExpired = _this.handleExpired.bind(_assertThisInitialized(_this));
    _this.handleErrored = _this.handleErrored.bind(_assertThisInitialized(_this));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.handleRecaptchaRef = _this.handleRecaptchaRef.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = ReCAPTCHA.prototype;

  _proto.getValue = function getValue() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      return this.props.grecaptcha.getResponse(this._widgetId);
    }

    return null;
  };

  _proto.getWidgetId = function getWidgetId() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      return this._widgetId;
    }

    return null;
  };

  _proto.execute = function execute() {
    var grecaptcha = this.props.grecaptcha;

    if (grecaptcha && this._widgetId !== undefined) {
      return grecaptcha.execute(this._widgetId);
    } else {
      this._executeRequested = true;
    }
  };

  _proto.executeAsync = function executeAsync() {
    var _this2 = this;

    return new Promise(function (resolve, reject) {
      _this2.executionResolve = resolve;
      _this2.executionReject = reject;

      _this2.execute();
    });
  };

  _proto.reset = function reset() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      this.props.grecaptcha.reset(this._widgetId);
    }
  };

  _proto.handleExpired = function handleExpired() {
    if (this.props.onExpired) {
      this.props.onExpired();
    } else {
      this.handleChange(null);
    }
  };

  _proto.handleErrored = function handleErrored() {
    if (this.props.onErrored) {
      this.props.onErrored();
    }

    if (this.executionReject) {
      this.executionReject();
      delete this.executionResolve;
      delete this.executionReject;
    }
  };

  _proto.handleChange = function handleChange(token) {
    if (this.props.onChange) {
      this.props.onChange(token);
    }

    if (this.executionResolve) {
      this.executionResolve(token);
      delete this.executionReject;
      delete this.executionResolve;
    }
  };

  _proto.explicitRender = function explicitRender() {
    if (this.props.grecaptcha && this.props.grecaptcha.render && this._widgetId === undefined) {
      var wrapper = document.createElement("div");
      this._widgetId = this.props.grecaptcha.render(wrapper, {
        sitekey: this.props.sitekey,
        callback: this.handleChange,
        theme: this.props.theme,
        type: this.props.type,
        tabindex: this.props.tabindex,
        "expired-callback": this.handleExpired,
        "error-callback": this.handleErrored,
        size: this.props.size,
        stoken: this.props.stoken,
        hl: this.props.hl,
        badge: this.props.badge
      });
      this.captcha.appendChild(wrapper);
    }

    if (this._executeRequested && this.props.grecaptcha && this._widgetId !== undefined) {
      this._executeRequested = false;
      this.execute();
    }
  };

  _proto.componentDidMount = function componentDidMount() {
    this.explicitRender();
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    this.explicitRender();
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this._widgetId !== undefined) {
      this.delayOfCaptchaIframeRemoving();
      this.reset();
    }
  };

  _proto.delayOfCaptchaIframeRemoving = function delayOfCaptchaIframeRemoving() {
    var temporaryNode = document.createElement("div");
    document.body.appendChild(temporaryNode);
    temporaryNode.style.display = "none"; // move of the recaptcha to a temporary node

    while (this.captcha.firstChild) {
      temporaryNode.appendChild(this.captcha.firstChild);
    } // delete the temporary node after reset will be done


    setTimeout(function () {
      document.body.removeChild(temporaryNode);
    }, 5000);
  };

  _proto.handleRecaptchaRef = function handleRecaptchaRef(elem) {
    this.captcha = elem;
  };

  _proto.render = function render() {
    // consume properties owned by the reCATPCHA, pass the rest to the div so the user can style it.

    /* eslint-disable no-unused-vars */
    var _this$props = this.props,
        sitekey = _this$props.sitekey,
        onChange = _this$props.onChange,
        theme = _this$props.theme,
        type = _this$props.type,
        tabindex = _this$props.tabindex,
        onExpired = _this$props.onExpired,
        onErrored = _this$props.onErrored,
        size = _this$props.size,
        stoken = _this$props.stoken,
        grecaptcha = _this$props.grecaptcha,
        badge = _this$props.badge,
        hl = _this$props.hl,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["sitekey", "onChange", "theme", "type", "tabindex", "onExpired", "onErrored", "size", "stoken", "grecaptcha", "badge", "hl"]);
    /* eslint-enable no-unused-vars */


    return react.createElement("div", _extends({}, childProps, {
      ref: this.handleRecaptchaRef
    }));
  };

  return ReCAPTCHA;
}(react.Component);


ReCAPTCHA.displayName = "ReCAPTCHA";
ReCAPTCHA.propTypes = {
  sitekey: (prop_types_default()).string.isRequired,
  onChange: (prop_types_default()).func,
  grecaptcha: (prop_types_default()).object,
  theme: prop_types_default().oneOf(["dark", "light"]),
  type: prop_types_default().oneOf(["image", "audio"]),
  tabindex: (prop_types_default()).number,
  onExpired: (prop_types_default()).func,
  onErrored: (prop_types_default()).func,
  size: prop_types_default().oneOf(["compact", "normal", "invisible"]),
  stoken: (prop_types_default()).string,
  hl: (prop_types_default()).string,
  badge: prop_types_default().oneOf(["bottomright", "bottomleft", "inline"])
};
ReCAPTCHA.defaultProps = {
  onChange: function onChange() {},
  theme: "light",
  type: "image",
  tabindex: 0,
  size: "normal",
  badge: "bottomright"
};
// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(8679);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
;// CONCATENATED MODULE: ./node_modules/react-async-script/lib/esm/async-script-loader.js
function async_script_loader_extends() { async_script_loader_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return async_script_loader_extends.apply(this, arguments); }

function async_script_loader_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function async_script_loader_inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }




var SCRIPT_MAP = {}; // A counter used to generate a unique id for each component that uses the function

var idCount = 0;
function makeAsyncScript(getScriptURL, options) {
  options = options || {};
  return function wrapWithAsyncScript(WrappedComponent) {
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";

    var AsyncScriptLoader =
    /*#__PURE__*/
    function (_Component) {
      async_script_loader_inheritsLoose(AsyncScriptLoader, _Component);

      function AsyncScriptLoader(props, context) {
        var _this;

        _this = _Component.call(this, props, context) || this;
        _this.state = {};
        _this.__scriptURL = "";
        return _this;
      }

      var _proto = AsyncScriptLoader.prototype;

      _proto.asyncScriptLoaderGetScriptLoaderID = function asyncScriptLoaderGetScriptLoaderID() {
        if (!this.__scriptLoaderID) {
          this.__scriptLoaderID = "async-script-loader-" + idCount++;
        }

        return this.__scriptLoaderID;
      };

      _proto.setupScriptURL = function setupScriptURL() {
        this.__scriptURL = typeof getScriptURL === "function" ? getScriptURL() : getScriptURL;
        return this.__scriptURL;
      };

      _proto.asyncScriptLoaderHandleLoad = function asyncScriptLoaderHandleLoad(state) {
        var _this2 = this;

        // use reacts setState callback to fire props.asyncScriptOnLoad with new state/entry
        this.setState(state, function () {
          return _this2.props.asyncScriptOnLoad && _this2.props.asyncScriptOnLoad(_this2.state);
        });
      };

      _proto.asyncScriptLoaderTriggerOnScriptLoaded = function asyncScriptLoaderTriggerOnScriptLoaded() {
        var mapEntry = SCRIPT_MAP[this.__scriptURL];

        if (!mapEntry || !mapEntry.loaded) {
          throw new Error("Script is not loaded.");
        }

        for (var obsKey in mapEntry.observers) {
          mapEntry.observers[obsKey](mapEntry);
        }

        delete window[options.callbackName];
      };

      _proto.componentDidMount = function componentDidMount() {
        var _this3 = this;

        var scriptURL = this.setupScriptURL();
        var key = this.asyncScriptLoaderGetScriptLoaderID();
        var _options = options,
            globalName = _options.globalName,
            callbackName = _options.callbackName,
            scriptId = _options.scriptId; // check if global object already attached to window

        if (globalName && typeof window[globalName] !== "undefined") {
          SCRIPT_MAP[scriptURL] = {
            loaded: true,
            observers: {}
          };
        } // check if script loading already


        if (SCRIPT_MAP[scriptURL]) {
          var entry = SCRIPT_MAP[scriptURL]; // if loaded or errored then "finish"

          if (entry && (entry.loaded || entry.errored)) {
            this.asyncScriptLoaderHandleLoad(entry);
            return;
          } // if still loading then callback to observer queue


          entry.observers[key] = function (entry) {
            return _this3.asyncScriptLoaderHandleLoad(entry);
          };

          return;
        }
        /*
         * hasn't started loading
         * start the "magic"
         * setup script to load and observers
         */


        var observers = {};

        observers[key] = function (entry) {
          return _this3.asyncScriptLoaderHandleLoad(entry);
        };

        SCRIPT_MAP[scriptURL] = {
          loaded: false,
          observers: observers
        };
        var script = document.createElement("script");
        script.src = scriptURL;
        script.async = true;

        for (var attribute in options.attributes) {
          script.setAttribute(attribute, options.attributes[attribute]);
        }

        if (scriptId) {
          script.id = scriptId;
        }

        var callObserverFuncAndRemoveObserver = function callObserverFuncAndRemoveObserver(func) {
          if (SCRIPT_MAP[scriptURL]) {
            var mapEntry = SCRIPT_MAP[scriptURL];
            var observersMap = mapEntry.observers;

            for (var obsKey in observersMap) {
              if (func(observersMap[obsKey])) {
                delete observersMap[obsKey];
              }
            }
          }
        };

        if (callbackName && typeof window !== "undefined") {
          window[callbackName] = function () {
            return _this3.asyncScriptLoaderTriggerOnScriptLoaded();
          };
        }

        script.onload = function () {
          var mapEntry = SCRIPT_MAP[scriptURL];

          if (mapEntry) {
            mapEntry.loaded = true;
            callObserverFuncAndRemoveObserver(function (observer) {
              if (callbackName) {
                return false;
              }

              observer(mapEntry);
              return true;
            });
          }
        };

        script.onerror = function () {
          var mapEntry = SCRIPT_MAP[scriptURL];

          if (mapEntry) {
            mapEntry.errored = true;
            callObserverFuncAndRemoveObserver(function (observer) {
              observer(mapEntry);
              return true;
            });
          }
        };

        document.body.appendChild(script);
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        // Remove tag script
        var scriptURL = this.__scriptURL;

        if (options.removeOnUnmount === true) {
          var allScripts = document.getElementsByTagName("script");

          for (var i = 0; i < allScripts.length; i += 1) {
            if (allScripts[i].src.indexOf(scriptURL) > -1) {
              if (allScripts[i].parentNode) {
                allScripts[i].parentNode.removeChild(allScripts[i]);
              }
            }
          }
        } // Clean the observer entry


        var mapEntry = SCRIPT_MAP[scriptURL];

        if (mapEntry) {
          delete mapEntry.observers[this.asyncScriptLoaderGetScriptLoaderID()];

          if (options.removeOnUnmount === true) {
            delete SCRIPT_MAP[scriptURL];
          }
        }
      };

      _proto.render = function render() {
        var globalName = options.globalName; // remove asyncScriptOnLoad from childProps

        var _this$props = this.props,
            asyncScriptOnLoad = _this$props.asyncScriptOnLoad,
            forwardedRef = _this$props.forwardedRef,
            childProps = async_script_loader_objectWithoutPropertiesLoose(_this$props, ["asyncScriptOnLoad", "forwardedRef"]); // eslint-disable-line no-unused-vars


        if (globalName && typeof window !== "undefined") {
          childProps[globalName] = typeof window[globalName] !== "undefined" ? window[globalName] : undefined;
        }

        childProps.ref = forwardedRef;
        return (0,react.createElement)(WrappedComponent, childProps);
      };

      return AsyncScriptLoader;
    }(react.Component); // Note the second param "ref" provided by React.forwardRef.
    // We can pass it along to AsyncScriptLoader as a regular prop, e.g. "forwardedRef"
    // And it can then be attached to the Component.


    var ForwardedComponent = (0,react.forwardRef)(function (props, ref) {
      return (0,react.createElement)(AsyncScriptLoader, async_script_loader_extends({}, props, {
        forwardedRef: ref
      }));
    });
    ForwardedComponent.displayName = "AsyncScriptLoader(" + wrappedComponentName + ")";
    ForwardedComponent.propTypes = {
      asyncScriptOnLoad: (prop_types_default()).func
    };
    return hoist_non_react_statics_cjs_default()(ForwardedComponent, WrappedComponent);
  };
}
;// CONCATENATED MODULE: ./node_modules/react-google-recaptcha/lib/esm/recaptcha-wrapper.js


var callbackName = "onloadcallback";
var globalName = "grecaptcha";

function getOptions() {
  return typeof window !== "undefined" && window.recaptchaOptions || {};
}

function getURL() {
  var dynamicOptions = getOptions();
  var hostname = dynamicOptions.useRecaptchaNet ? "recaptcha.net" : "www.google.com";
  return "https://" + hostname + "/recaptcha/api.js?onload=" + callbackName + "&render=explicit";
}

/* harmony default export */ var recaptcha_wrapper = (makeAsyncScript(getURL, {
  callbackName: callbackName,
  globalName: globalName
})(ReCAPTCHA));
;// CONCATENATED MODULE: ./node_modules/react-google-recaptcha/lib/esm/index.js


/* harmony default export */ var esm = (recaptcha_wrapper);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [282,2215,15350,79593,68480,1111,57443,94108,74805,18450,51656,230,19789,29705,79956,30305,88346,93166,14097,49774,92888,40179], function() { return __webpack_exec__(79341); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);